export const emojiList = [
  {
    name: '+1',
    short_names: ['+1'],
    imageUrl: '',
    emoticons: [],
    keywords: ['thumbsup'],
  },
  {
    name: '-1',
    short_names: ['-1'],
    imageUrl: '',
    emoticons: [],
    keywords: ['-1', 'cheering megaphone'],
  },
  {
    name: 'clap',
    short_names: ['clap'],
    imageUrl: '',
    emoticons: [],
    keywords: ['clap'],
  },
  {
    name: 'scream',
    short_names: ['scream'],
    imageUrl: '',
    emoticons: [],
    keywords: ['scream'],
  },
  {
    name: 'rocket',
    short_names: ['rocket'],
    imageUrl: '',
    emoticons: [],
    keywords: ['rocket'],
  },
  {
    name: 'fire',
    short_names: ['fire'],
    imageUrl: '',
    emoticons: [],
    keywords: ['fire'],
  },
  {
    name: 'heart_eyes',
    short_names: ['heart_eyes'],
    imageUrl: '',
    emoticons: [],
    keywords: ['heart_eyes'],
  },
  {
    name: 'laughing',
    short_names: ['laughing'],
    imageUrl: '',
    emoticons: [],
    keywords: ['laughing'],
  },
];
